import { render, staticRenderFns } from "./SearchYingyou.vue?vue&type=template&id=5b182472&scoped=true&"
import script from "./SearchYingyou.vue?vue&type=script&lang=js&"
export * from "./SearchYingyou.vue?vue&type=script&lang=js&"
import style0 from "./SearchYingyou.vue?vue&type=style&index=0&id=5b182472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b182472",
  null
  
)

export default component.exports